import { useState as f, useEffect as c } from "react";
import { registerStoryblokBridge as k } from "./storyblok-js.mjs";
import { BlockTypes as g, MarkTypes as v, RichTextResolver as R, RichTextSchema as T, TextTypes as h, apiPlugin as B, loadStoryblokBridge as C, renderRichText as E, richTextResolver as w, storyblokEditable as A } from "./storyblok-js.mjs";
import { useStoryblokApi as u } from "./index2.mjs";
import { getComponent as F, getCustomFallbackComponent as L, getEnableFallbackComponent as P, setComponents as _, storyblokInit as q } from "./index2.mjs";
import { useStoryblokState as M } from "./client.mjs";
import { useStoryblokRichTextResolver as Y } from "./richtext.mjs";
import { default as j } from "./storyblok-rich-text.mjs";
import { convertAttributesInElement as D } from "./utils.mjs";
import { default as H } from "./storyblok-component.mjs";
const d = (s, o = {}, e = {}) => {
  const [n, l] = f({}), i = typeof window < "u" && typeof window.storyblokRegisterEvent < "u", t = u();
  return c(() => {
    if (!t) {
      console.error(
        "You can't use useStoryblok if you're not loading apiPlugin."
      );
      return;
    }
    async function a() {
      const { data: r } = await t.get(
        `cdn/stories/${s}`,
        o
      );
      l(r.story), i && r.story.id && k(
        r.story.id,
        (y) => l(y),
        e
      );
    }
    a();
  }, [s, JSON.stringify(o), t]), t ? (e.resolveRelations = e.resolveRelations ?? o.resolve_relations, e.resolveLinks = e.resolveLinks ?? o.resolve_links, n) : null;
};
export {
  g as BlockTypes,
  v as MarkTypes,
  R as RichTextResolver,
  T as RichTextSchema,
  H as StoryblokComponent,
  j as StoryblokRichText,
  h as TextTypes,
  B as apiPlugin,
  D as convertAttributesInElement,
  F as getComponent,
  L as getCustomFallbackComponent,
  P as getEnableFallbackComponent,
  u as getStoryblokApi,
  C as loadStoryblokBridge,
  k as registerStoryblokBridge,
  E as renderRichText,
  w as richTextResolver,
  _ as setComponents,
  A as storyblokEditable,
  q as storyblokInit,
  d as useStoryblok,
  u as useStoryblokApi,
  k as useStoryblokBridge,
  Y as useStoryblokRichTextResolver,
  M as useStoryblokState
};
